
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/approvedReviews",
      function () {
        return require("private-next-pages/approvedReviews/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/approvedReviews"])
      });
    }
  